import { createContext, useRef, useState } from "react";

export const BlockerContext = createContext<any>("");

export enum steps {
  RELOAD,
  FINISHED,
  SIGNUP,
  SIGNIN,
  LOADING,
  AWLAD_SCHOOL,
  STUDENT_PROFIL,
  DONATION
}

const BlockerContextProvider = (props: any) => {
	const [block, setBlock] = useState<boolean>();
	const [itemId, setItemId] = useState<string>();
  const [unblockStep, setUnblockStep] = useState<steps>(props.initialSteps || steps.AWLAD_SCHOOL);
  const nextStep = useRef<steps | undefined>(props.nextSteps);

	return (
		<BlockerContext.Provider value={{ itemId, setItemId, block, setBlock, unblockStep, setUnblockStep, nextStep }} >
			{props.children}
		</BlockerContext.Provider>
	);
};

export default BlockerContextProvider;
